
<script setup lang="ts">
import EditorView from '@/components/EditorView.vue';
interface Props {
    content: any;
}
const props = defineProps<Props>();

</script>
<template>
    <EditorView :content='props.content'></EditorView>
</template>